const DEV_WEB_API_URL = 'https://test1.avelia.chat/api/web'
const PROD_WEB_API_URL = 'https://api.avelia.chat/api/web'
const DEV_CORE_API_URL = 'https://test1.avelia.chat/api/v1'
const PROD_CORE_API_URL = 'https://api.avelia.chat/api/v1'

export const WEB_API_BASE_URL = import.meta.env.DEV ? DEV_WEB_API_URL : PROD_WEB_API_URL
export const CORE_API_BASE_URL = import.meta.env.DEV ? DEV_CORE_API_URL : PROD_CORE_API_URL
export const API_ENDPOINTS = {
  GET_LATEST_VERSION: `${CORE_API_BASE_URL}/public/releases/latest`,
  RECORD_WEBSITE_VISIT: `${CORE_API_BASE_URL}/public/website-visits`,
  GET_VERSION_LIST: `${WEB_API_BASE_URL}/getVersionList`,
  RECORD_DOWNLOAD: `${WEB_API_BASE_URL}/recordDownload`,
  GET_SKILL_LIST: `${CORE_API_BASE_URL}/skill/index`,
  GET_SKILL_DETAIL: `${CORE_API_BASE_URL}/skill/detail`,
}

const CACHE_DURATION = 30000; // 30 seconds in milliseconds

export const request = async (url, options = {}) => {
  const isList = url.includes('skill/index');
  const isDetail = url.includes('skill/detail');
  const isCacheable = (isList || isDetail) && (!options.method || options.method.toUpperCase() === 'GET');

  const cacheKey = isList ? 'api_cache_skill_list' : (isDetail ? 'api_cache_skill_detail' : null);
  const requestId = url + JSON.stringify(options);

  if (isCacheable && cacheKey) {
    try {
      const store = JSON.parse(localStorage.getItem(cacheKey) || '{}');
      const entry = store[requestId];
      if (entry && Date.now() - entry.t < CACHE_DURATION) {
        return entry.d;
      }
    } catch (e) {
      console.warn('Cache read error:', e);
    }
  }

  try {
    const response = await fetch(url, {
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    })

    const data = await response.json()

    if (isCacheable && cacheKey) {
      try {
        const store = JSON.parse(localStorage.getItem(cacheKey) || '{}');
        const now = Date.now();
        // Clean expired entries
        for (const key in store) {
          if (now - store[key].t >= CACHE_DURATION) delete store[key];
        }
        store[requestId] = { d: data, t: now };
        localStorage.setItem(cacheKey, JSON.stringify(store));
      } catch (e) {
        console.warn('Cache write error:', e);
      }
    }

    return data
  } catch (error) {
    console.error('API请求失败:', error)
    throw error
  }
}
